export default "__VITE_ASSET__3RtW0HzN__"